var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginPageDesktopBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1731,
    height: 1728,
    viewBox: "0 0 1731 1728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1119.5 1256.62C1119.5 1061.36 1088.76 812.5 1424.63 903.077C1760.5 993.653 1729.76 1061.36 1729.76 1256.62C1729.76 1451.87 1593.15 1610.15 1424.63 1610.15C1256.11 1610.15 1119.5 1451.87 1119.5 1256.62Z",
    fill: "url(#paint0_radial_407_791)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.72 204.681C1248.49 76.4998 1294.35 0.000205958 1412.31 0.000219543C1530.27 0.000233128 1625.9 91.6388 1625.9 204.681C1625.9 317.723 1530.27 409.361 1412.31 409.361C624.495 409.361 1148.95 332.861 1198.72 204.681Z",
    fill: "url(#paint1_radial_407_791)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.399 81.9161C102.399 -102.392 350.642 81.9162 509.706 81.9162C753.278 81.9162 1133.41 -102.392 1133.41 81.9161C1133.41 266.225 876.061 419.286 578.495 448.5C423.069 463.76 306.399 388.001 102.399 473.5C-20.9178 525.184 102.399 183.53 102.399 81.9161Z",
    fill: "url(#paint2_radial_407_791)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M542.259 587.5C532.339 473.438 1208.9 447.711 1251.72 447.711C1420.24 447.711 1729.76 478.845 1729.76 674.099C1729.76 869.354 1420.24 833.502 1251.72 833.502C1083.21 833.502 555.87 744 542.259 587.5Z",
    fill: "url(#paint3_radial_407_791)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.95 847.79C1128.18 900.327 1085.21 1254.17 832.826 1369.82C597.366 1477.7 404.259 1395.97 342.287 1214.4C328.438 1047.33 593.043 1198.22 749.752 1126.42C819.624 1094.4 671.536 976.421 701.759 912C739.32 831.937 952.064 809.819 1025.95 847.79Z",
    fill: "url(#paint4_radial_407_791)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7593 947.679C30.7593 700.976 140.055 500.984 274.879 500.984C409.703 500.984 633.259 759.297 633.259 1006C633.259 1252.7 197.759 681.5 274.879 1394.37C296.367 1593.01 30.7593 1194.38 30.7593 947.679Z",
    fill: "url(#paint5_radial_407_791)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15871 1511.49C7.97756 1453.07 239.496 1604.5 274.496 1490C322.84 1331.85 474.996 1596 902.354 1433.7C1020.58 1388.8 1136.64 1437.05 1142.84 1511.48C1149.04 1585.91 1085.42 1622.21 917.516 1638.87C249.938 1650.42 3.15875 1584.67 3.15871 1511.49Z",
    fill: "url(#paint6_radial_407_791)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_407_791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1424.63 1256.62) rotate(-90) scale(353.539 305.129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_407_791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1412.31 204.681) rotate(-90) scale(204.68 213.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#8A73DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C551"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_407_791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(617.906 236.934) rotate(-90) scale(236.933 515.507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_407_791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1112.49 641.9) rotate(-90) scale(194.189 617.267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#3C5BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A73DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_407_791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(744.754 1176.35) rotate(71.1548) scale(213.65 393.183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#3C5BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A73DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_407_791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.259 973.715) rotate(-90) scale(472.731 250.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_407_791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(576.155 1554.75) rotate(-94.2264) scale(117.443 568.338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5BA6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageDesktopBackground);
export default __webpack_public_path__ + "static/media/Login Page _ Desktop Background.d76824e4e8da0ee54042e02021e55e05.svg";
export { ForwardRef as ReactComponent };